function InfoUser(){
  return(
    <>
      InfoUser
    </>
  )
}
export default InfoUser;